const images = [
    '/public-data/bg-header.jpg',
    '/public-data/bg-header-2.webp',
    '/public-data/bg-header-3.webp',
];

const togglers = document.querySelectorAll('.header-images-togglers .header-images-toggler');

const bg1 = document.querySelector('.header-images .bg1');
const bg2 = document.querySelector('.header-images .bg2');

let current = 0;
let showingBg1 = true;

// Inicializace
togglers[0].classList.add('ring-3');

function changeBackground() {
    const nextImage = images[(current + 1) % images.length];
    const nextLayer = showingBg1 ? bg2 : bg1;
    const currentLayer = showingBg1 ? bg1 : bg2;

    // Předehrajeme obrázek
    const img = new Image();
    img.src = nextImage;
    img.onload = () => {
        nextLayer.style.backgroundImage = "url('" + nextImage + "')";

        // Přepneme vrstvy
        nextLayer.classList.add('visible');
        currentLayer.classList.remove('visible');

        togglers[current].classList.remove('ring-3');
        // Posuneme index a toggle
        current = (current + 1) % images.length;
        showingBg1 = !showingBg1;
        togglers[current].classList.add('ring-3');
    };
}

setInterval(changeBackground, 15000);